// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2716%27 height=%2716%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27%23666%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3E%3Crect x=%273%27 y=%274%27 width=%2718%27 height=%2718%27 rx=%272%27 ry=%272%27%3E%3C/rect%3E%3Cline x1=%2716%27 y1=%272%27 x2=%2716%27 y2=%276%27%3E%3C/line%3E%3Cline x1=%278%27 y1=%272%27 x2=%278%27 y2=%276%27%3E%3C/line%3E%3Cline x1=%273%27 y1=%2710%27 x2=%2721%27 y2=%2710%27%3E%3C/line%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.info-section {
  padding: 2rem;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.06);
  width: 100%;
}

.info-section h3 {
  font-size: 1rem;
  color: #2a2a2a;
  font-weight: 500;
  margin-bottom: 20px;
}

.info-section p {
  color: #666;
  font-size: 0.8rem;
  margin-bottom: 12px;
}

.info-section form {
  display: grid;
  gap: 1.25rem;
  margin-top: 1.5rem;
}

.info-section input,
.info-section textarea {
  width: 100%;
  padding: 12px 16px;
  border: 1px solid #eee;
  border-radius: 8px;
  font-size: 0.95rem;
  background: #f9f9f9;
  transition: all 0.3s ease;
}

.info-section input:focus,
.info-section textarea:focus {
  outline: none;
  border-color: #e8c140;
  background: #fff;
  box-shadow: 0 0 0 3px rgba(232, 193, 64, 0.1);
}

.info-section textarea {
  height: 50px;
  resize: none;
  line-height: 1.3;
}

.details-destination {
  font-size: 0.9rem;
  color: #004d00;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 8px;
  font-weight: 500;
  display: inline-flex;
  align-items: center;
}


::placeholder {
  color: #999;
  font-size: 0.85rem;
}

.info-section .btn-green {
    padding: 10px;
    border-radius: 5px;
    cursor: pointer;
    font-size:1.2rem;
    border: none;
  }

.info-section .btn-green:hover {
  background-color: #004d00ab;
}

.info-section input[type="date"] {
  -webkit-appearance: none;
  -webkit-min-logical-width: calc(100% - 16px);
  position: relative;
  background-color: #f9f9f9;
}
.info-section form > div {
  position: relative;
}

.info-section input[type="date"] + .calendar-icon {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 16px;
  height: 16px;
  pointer-events: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: contain;
  background-repeat: no-repeat;
}
.info-section input[type="date"]::after {
  display: none;
}

@media (max-width: 768px) {
  .info-section {
    padding: 20px;
  }
}

@media (max-width: 480px) {
  .info-section {
    width: 100%;
    padding: 15px;
  }
}

.date-input-container {
  position: relative;
}

.date-icon {
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  color: #666;
  pointer-events: none;
}

.styled-datepicker-input {
  height: 50px;
  padding-right: 40px !important;
  cursor: pointer;
}

input[type="date"]::-webkit-calendar-picker-indicator {
  opacity: 0;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/surveyForm.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,0CAA0C;EAC1C,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;;EAEE,aAAa;EACb,qBAAqB;EACrB,gBAAgB;EAChB,6CAA6C;AAC/C;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;AACrB;;;AAGA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,YAAY;EACd;;AAEF;EACE,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,4CAA4C;EAC5C,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,yDAAuc;EACvc,wBAAwB;EACxB,4BAA4B;AAC9B;AACA;EACE,aAAa;AACf;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,WAAW;IACX,aAAa;EACf;AACF;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,eAAe;AACjB","sourcesContent":[".info-section {\n  padding: 2rem;\n  background: #fff;\n  border-radius: 16px;\n  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.06);\n  width: 100%;\n}\n\n.info-section h3 {\n  font-size: 1rem;\n  color: #2a2a2a;\n  font-weight: 500;\n  margin-bottom: 20px;\n}\n\n.info-section p {\n  color: #666;\n  font-size: 0.8rem;\n  margin-bottom: 12px;\n}\n\n.info-section form {\n  display: grid;\n  gap: 1.25rem;\n  margin-top: 1.5rem;\n}\n\n.info-section input,\n.info-section textarea {\n  width: 100%;\n  padding: 12px 16px;\n  border: 1px solid #eee;\n  border-radius: 8px;\n  font-size: 0.95rem;\n  background: #f9f9f9;\n  transition: all 0.3s ease;\n}\n\n.info-section input:focus,\n.info-section textarea:focus {\n  outline: none;\n  border-color: #e8c140;\n  background: #fff;\n  box-shadow: 0 0 0 3px rgba(232, 193, 64, 0.1);\n}\n\n.info-section textarea {\n  height: 50px;\n  resize: none;\n  line-height: 1.3;\n}\n\n.details-destination {\n  font-size: 0.9rem;\n  color: #004d00;\n  border: none;\n  padding: 0.5rem 1rem;\n  border-radius: 8px;\n  font-weight: 500;\n  display: inline-flex;\n  align-items: center;\n}\n\n\n::placeholder {\n  color: #999;\n  font-size: 0.85rem;\n}\n\n.info-section .btn-green {\n    padding: 10px;\n    border-radius: 5px;\n    cursor: pointer;\n    font-size:1.2rem;\n    border: none;\n  }\n\n.info-section .btn-green:hover {\n  background-color: #004d00ab;\n}\n\n.info-section input[type=\"date\"] {\n  -webkit-appearance: none;\n  -webkit-min-logical-width: calc(100% - 16px);\n  position: relative;\n  background-color: #f9f9f9;\n}\n.info-section form > div {\n  position: relative;\n}\n\n.info-section input[type=\"date\"] + .calendar-icon {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 16px;\n  height: 16px;\n  pointer-events: none;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%23666' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Crect x='3' y='4' width='18' height='18' rx='2' ry='2'%3E%3C/rect%3E%3Cline x1='16' y1='2' x2='16' y2='6'%3E%3C/line%3E%3Cline x1='8' y1='2' x2='8' y2='6'%3E%3C/line%3E%3Cline x1='3' y1='10' x2='21' y2='10'%3E%3C/line%3E%3C/svg%3E\");\n  background-size: contain;\n  background-repeat: no-repeat;\n}\n.info-section input[type=\"date\"]::after {\n  display: none;\n}\n\n@media (max-width: 768px) {\n  .info-section {\n    padding: 20px;\n  }\n}\n\n@media (max-width: 480px) {\n  .info-section {\n    width: 100%;\n    padding: 15px;\n  }\n}\n\n.date-input-container {\n  position: relative;\n}\n\n.date-icon {\n  position: absolute;\n  right: 16px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: #666;\n  pointer-events: none;\n}\n\n.styled-datepicker-input {\n  height: 50px;\n  padding-right: 40px !important;\n  cursor: pointer;\n}\n\ninput[type=\"date\"]::-webkit-calendar-picker-indicator {\n  opacity: 0;\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  top: 0;\n  left: 0;\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
